export enum ErrorCorrectionsScriptResult {
	Failed = 'Failed',
	Done = 'Done',
}

export enum UserStatisticStatus {
	Normal = 'normal',
	Critical = 'critical',
	Minor = 'minor',
}
